import React from "react";
import styled from "styled-components";
import StarRating from "../StarRating";
import "../Review.scss";

const HeaderWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

const RatingSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  @media (min-width: 768px) {
    align-items: flex-start;
  }
`;

const RatingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;

  .fdn-rating-summary {
    font-size: 30px;
  }
`;

const RatingNumber = styled.span`
  font-size: 30px;
  font-weight: 700;
  color: #ffc834;
  line-height: 1;
`;

const CountLink = styled.a`
  color: #5b9bd5;
  text-decoration: none;
  font-size: 0.95em;
  text-align: center;

  @media (min-width: 768px) {
    text-align: left;
  }

  &:hover {
    text-decoration: underline;
  }
`;

const ButtonWrapper = styled.div`
  position: absolute;
  min-width: 15em;
  bottom: 0;
  right: 0;
  text-align: center;
  margin-top: 8px;

  a {
    margin: 0 !important;
  }

  @media (max-width: 600px) {
    position: relative;
    margin: 1em auto 0;
  }
`;

const CarouselHeader = ({ merchant, truncateDest, isCancelled }) => {
  const { averageRating, numRatings, numReviews, surveyUrl } = merchant;
  const totalCount = numRatings || numReviews;

  const handleWriteClick = (e) => {
    if (surveyUrl) {
      e.preventDefault();
      window.open(surveyUrl, "Write a Review", "width=600,height=700");
    }
  };

  const showWrite = !isCancelled && surveyUrl;

  return (
    <HeaderWrapper className="fdn-carousel-header">
      <RatingSection className="fdn-carousel-rating">
        <RatingRow className="fdn-carousel-row">
          <RatingNumber className="fdn-carousel-rating-number">
            {averageRating ? averageRating.toFixed(1) : "0.0"}
          </RatingNumber>
          <StarRating rating={averageRating || 0} className="fdn-rating-summary" />
        </RatingRow>
        <CountLink className="fdn-carousel-count-link" href={truncateDest}>
          {totalCount} {totalCount === 1 ? "Rating" : "Ratings"} &amp; Reviews &rarr;
        </CountLink>
      </RatingSection>
      {showWrite && (
        <ButtonWrapper className="button">
          <a
            href={surveyUrl}
            className="dmButtonLink dmWidget dmWwr default dmOnlyButton dmDefaultGradient"
            data-display-type="block"
            onClick={handleWriteClick}
          >
            <span className="text">Write a Review</span>
          </a>
        </ButtonWrapper>
      )}
    </HeaderWrapper>
  );
};

export default CarouselHeader;



// WEBPACK FOOTER //
// ./src/components/carousel/CarouselHeader.jsx